// extracted by mini-css-extract-plugin
module.exports = {"outter":"MessageService_outter__3197w","test":"MessageService_test__1iSj9","root":"MessageService_root__24URu"};